export const PLAN_LIMITS = {
  trial: 5,       // lifetime
  starter: 50,    // per billing period
  pro: Infinity
};

export const PLAN_LABELS = {
  trial: 'Trial',
  starter: 'Starter',
  pro: 'Pro'
};

export function planLimit(plan) {
  return PLAN_LIMITS[plan] ?? 0;
}

export function remaining(plan, used) {
  const lim = planLimit(plan);
  if (lim === Infinity) return Infinity;
  return Math.max(0, lim - used);
}

export function canGenerate(plan, used) {
  return remaining(plan, used) > 0;
}

export function usageLabel(plan, used) {
  if (plan === 'pro') return 'Pro · unlimited';
  const lim = planLimit(plan);
  return `${PLAN_LABELS[plan] || plan}: ${used}/${lim}`;
}
